import { FormControl, Select, MenuItem } from "@mui/material";
import { SettingCard } from "./settings-card";
import type { SelectChangeEvent } from "@mui/material";

type DropdownSelectProps = {
  title: string;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  options: string[];
};

export const DropdownSelect = ({
  title,
  value,
  onChange,
  options,
}: DropdownSelectProps) => {
  return (
    <SettingCard title={title}>
      <FormControl sx={{ minWidth: "20%" }} size="small">
        <Select
          labelId="select-label"
          id="select"
          value={value}
          onChange={onChange}
          MenuProps={{
            PaperProps: {
              sx: { textAlign: "center" },
            },
          }}
        >
          {options.map((option) => (
            <MenuItem key={option} value={option} sx={{ textAlign: "center" }}>
              {option.charAt(0).toUpperCase() + option.slice(1)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </SettingCard>
  );
};
